import request from '@/utils/request'

// 获取会员配置列表
export function getMemberConfigList(data) {
  return request({
    url: '/admin/operate/webMemberConfig/list',
    method: 'post',
    data
  })
}

// 新增会员配置
export function addMemberConfig(data) {
  return request({
    url: '/admin/operate/webMemberConfig/add',
    method: 'post',
    data
  })
}

// 编辑会员配置
export function updateMemberConfig(data) {
  return request({
    url: '/admin/operate/webMemberConfig/edit',
    method: 'post',
    data
  })
}

// 删除会员配置
export function removeMemberConfig(data) {
  return request({
    url: '/admin/operate/webMemberConfig/remove',
    method: 'post',
    data
  })
}

// CRM 会员等级列表
export function getCrmMemberLevelList(data) {
  return request({
    url: '/admin/operate/webTicketMan/crmMemberLevelList',
    method: 'get',
    data
  })
}
